import { WithChildren } from '@vertex-protocol/web-common';
import { useSizeClass } from 'client/hooks/ui/breakpoints';
import {
  AnalyticsContext,
  AnalyticsContextData,
} from 'client/modules/analytics/AnalyticsContext';
import { AnalyticsGlobalEventsReporter } from 'client/modules/analytics/AnalyticsGlobalEventsReporter';
import {
  AnalyticsBaseEventProperties,
  AnalyticsEvent,
} from 'client/modules/analytics/types';
import { clientEnv } from 'common/environment/clientEnv';
import { useCallback, useMemo } from 'react';

// Stack'd Perps: Spindl analytics removed. Analytics is a no-op stub.
export function AnalyticsContextProvider({ children }: WithChildren) {
  const { value: sizeClass } = useSizeClass();
  const {
    base: { buildId },
  } = clientEnv;

  const baseEventProperties = useMemo((): AnalyticsBaseEventProperties => {
    return {
      sizeClass,
      buildId,
    };
  }, [sizeClass, buildId]);

  const updateUserAddress = useCallback<
    AnalyticsContextData['updateUserAddress']
  >(
    async (_address: string) => {
      // no-op
    },
    [],
  );

  const trackEvent = useCallback<AnalyticsContextData['trackEvent']>(
    (_event: AnalyticsEvent) => {
      // no-op
    },
    [],
  );

  const value: AnalyticsContextData = useMemo(() => {
    return {
      updateUserAddress,
      trackEvent,
      areCookiesAccepted: false,
    };
  }, [updateUserAddress, trackEvent]);

  return (
    <AnalyticsContext.Provider value={value}>
      <AnalyticsGlobalEventsReporter />
      {children}
    </AnalyticsContext.Provider>
  );
}
